import { render } from "./Logo.vue?vue&type=template&id=42501888&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=42501888&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42501888"

export default script